import React, { useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { ROUTES } from "../../constants";
import { useTranslation } from "react-i18next";
import { AuthPageStyles } from "../../utilities/themeColors";
import useBrandingAssets from "../../hooks/useBrandingAssets";
import CompanyLogo from "../../components/CompanyLogo/CompanyLogo";

const Logout = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { authBackdropStyle } = useBrandingAssets();

    useEffect(() => {
        (async () => {
            await logout();
            // navigation handled in context; fallback just in case
            navigate(ROUTES.LOGIN);
        })();
    }, [logout, navigate]);

    return (
        <Box
            className="login-container"
            sx={authBackdropStyle || AuthPageStyles}
        >
            <Box className="login-form-container">
                <CompanyLogo alt="Logo" className="login-logo" />

                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mt={3}
                >
                    <Typography variant="h6" gutterBottom>
                        {t('BUTTON.LOGGING_IN')}
                    </Typography>

                    <CircularProgress sx={{ my: 2 }} />

                    <Typography variant="body2" color="text.secondary">
                        {t('GENERAL.REDIRECTING_TO_LOGIN')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Logout;
